// extracted by mini-css-extract-plugin
export default {"OfferCollapse":"NewOfferCollapse_OfferCollapse__BWWqZ","CollapsePanel":"NewOfferCollapse_CollapsePanel__mzFBN"};